import React, { useCallback, useEffect, useRef, useState } from 'react';
import SVG from 'react-inlinesvg';
import classname from 'classnames/bind';

import styles from './index.module.scss';
const cx = classname.bind(styles);

/**
 * @param type ('success'|'failure')
 * @param show (boolean)
 * @param autoDismiss (boolean)
 * @param onDismiss (function)
 * @param message
 */

const AppMessage = ({
  type = '',
  show = false,
  autoDismiss = true,
  onDismiss = () => undefined,
  message,
}) => {
  const [delay, setDelay] = useState(3000);
  const savedDismissFn = useRef(onDismiss);
  const IconImg = ({ type }) => {
    switch (type) {
      case 'success':
        return (
          <SVG
            className={styles.success}
            width={60}
            height={60}
            src="/assets/check-outlined.svg"
          />
        );
      case 'failure':
        return (
          <SVG
            className={styles.failure}
            width={60}
            height={60}
            src="/assets/close-outlined.svg"
          />
        );
      default:
        return <></>;
    }
  };

  const dismissHandler = useCallback(() => {
    if (autoDismiss) {
      setDelay(null);
      savedDismissFn.current();
    }
  }, [autoDismiss]);

  // 儲存最新的 onDismiss
  useEffect(() => {
    savedDismissFn.current = onDismiss;
  }, [onDismiss]);

  //  app message 出現時，設定 delay 為 3秒
  useEffect(() => {
    if (show) {
      setDelay(3000);
    }
  }, [show]);

  //  delay 變更時，設定 settimeout
  useEffect(() => {
    let timeoutId = '';
    if (autoDismiss && delay !== null) {
      timeoutId = setTimeout(dismissHandler, delay);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [delay, autoDismiss, dismissHandler]);

  const appMessageClasses = cx({
    'app-message': true,
    [type]: true,
    show,
  });

  return (
    <div className={appMessageClasses} onClick={dismissHandler}>
      <IconImg type={type} />
      {typeof message === 'string'
        ? message
            .split('\n')
            .map((line, index) => <p key={`${line}_${index}`}>{line}</p>)
        : message}
    </div>
  );
};

export default AppMessage;
